import axios, {
  type AxiosInstance,
  type InternalAxiosRequestConfig,
  type AxiosRequestConfig,
} from 'axios'
import { useAuthStore } from '@/features/auth/store/auth-store'

export { AxiosError } from 'axios'

const isDEV = import.meta.env.DEV
const DEV_BASE_URL = import.meta.env.VITE_DEV_BASE_URL
const PRO_BASE_URL = import.meta.env.VITE_PRO_BASE_URL

// 公共路由：仅对 GET 生效（自动加 /public 前缀）
const publicPaths = ['/engines']

const ApiInstance: AxiosInstance = axios.create({
  baseURL: isDEV ? DEV_BASE_URL : PRO_BASE_URL,
  timeout: Number(import.meta.env.VITE_TIMEOUT_TIME) * 1000,
  headers: {
    'Content-Type': 'application/json',
  },
})

ApiInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const token = useAuthStore.getState().auth.accessToken
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

export const origin_point_engine_api = <T>(
  config: AxiosRequestConfig
): Promise<T> => {
  const method = (config.method ?? 'GET').toUpperCase()

  // 仅 GET 且命中白名单才走 public
  if (method === 'GET' && config.url && publicPaths.includes(config.url)) {
    config.url = `/public${config.url}`
  }

  return ApiInstance({ ...config }).then(({ data }) => data)
}
